import dayjs from 'dayjs';
import { DataGridIdentifiers } from '../components/Interface';
import { DocStatus } from '../config/document';
import { DocumentType } from '../config/DocumentType';
import { v4 as uuidv4 } from 'uuid';
import addNotification from './addNotification';
import { NotificationType } from '../config';

export const getDocDataGridIdentifiers = (docTypeId) => {
  switch (parseInt(docTypeId)) {
    case DocumentType.SalesQuotation:
      return {
        doc: DataGridIdentifiers.SalesQuotationDoc,
        docLine: DataGridIdentifiers.SalesQuotationDocLine,
      };
    case DocumentType.CustomerOrder:
      return {
        doc: DataGridIdentifiers.CustomerOrderDoc,
        docLine: DataGridIdentifiers.CustomerOrderDocLine,
      };
    case DocumentType.Delivery:
      return {
        doc: DataGridIdentifiers.DeliveryNoteDoc,
        docLine: DataGridIdentifiers.DeliveryNoteDocLine,
      };
    case DocumentType.Return:
      return {
        doc: DataGridIdentifiers.ReturnDoc,
        docLine: DataGridIdentifiers.ReturnDocLine,
      };
    case DocumentType.DownPaymentRequest:
      return {
        doc: DataGridIdentifiers.DownPaymentRequestDoc,
        docLine: DataGridIdentifiers.DownPaymentRequestDocLine,
      };
    case DocumentType.DownPayment:
      return {
        doc: DataGridIdentifiers.DownPaymentDoc,
        docLine: DataGridIdentifiers.DownPaymentDocLine,
      };
    case DocumentType.ARInvoice:
      return {
        doc: DataGridIdentifiers.ARInvoiceDoc,
        docLine: DataGridIdentifiers.ARInvoiceDocLine,
      };
    case DocumentType.PurchaseRequest:
      return {
        doc: DataGridIdentifiers.PurchaseRequestDoc,
        docLine: DataGridIdentifiers.PurchaseRequestDocLine,
      };
    case DocumentType.PurchaseQuotation:
      return {
        doc: DataGridIdentifiers.PurchaseQuotationDoc,
        docLine: DataGridIdentifiers.PurchaseQuotationDocLine,
      };
    case DocumentType.PurchaseOrder:
      return {
        doc: DataGridIdentifiers.PurchaseOrderDoc,
        docLine: DataGridIdentifiers.PurchaseOrderDocLine,
      };
    case DocumentType.PurchaseDelivery:
      return {
        doc: DataGridIdentifiers.PurchaseDeliveryNoteDoc,
        docLine: DataGridIdentifiers.PurchaseDeliveryNoteDocLine,
      };
    case DocumentType.GoodsReturn:
      return {
        doc: DataGridIdentifiers.GoodsReturnDoc,
        docLine: DataGridIdentifiers.GoodsReturnDocLine,
      };
    case DocumentType.APDownPaymentRequest:
      return {
        doc: DataGridIdentifiers.APDownPaymentRequestDoc,
        docLine: DataGridIdentifiers.APDownPaymentRequestDocLine,
      };
    case DocumentType.PurchaseAdvanceInvoice:
      return {
        doc: DataGridIdentifiers.PurchaseAdvanceInvoiceDoc,
        docLine: DataGridIdentifiers.PurchaseAdvanceInvoiceDocLine,
      };
    case DocumentType.APInvoice:
      return {
        doc: DataGridIdentifiers.APInvoiceDoc,
        docLine: DataGridIdentifiers.APInvoiceDocLine,
      };
    case DocumentType.InventoryTransfer:
      return {
        doc: DataGridIdentifiers.InventoryTransferDoc,
        docLine: DataGridIdentifiers.InventoryTransferDocLine,
      };
    case DocumentType.GoodsReceipt:
      return {
        doc: DataGridIdentifiers.GoodsReceiptDoc,
        docLine: DataGridIdentifiers.GoodsReceiptDocLine,
      };
    case DocumentType.GoodsIssue:
      return {
        doc: DataGridIdentifiers.GoodsIssueDoc,
        docLine: DataGridIdentifiers.GoodsIssueDocLine,
      };
    case DocumentType.InventoryCounting:
      return {
        doc: DataGridIdentifiers.InventoryCountingDoc,
        docLine: DataGridIdentifiers.InventoryCountingDocLine,
      };
    case DocumentType.InventoryCountingDif:
      return {
        doc: DataGridIdentifiers.InventoryCountingDifDoc,
        docLine: DataGridIdentifiers.InventoryCountingDifDocLine,
      };
    case DocumentType.ReceiptFromProduction:
      return {
        doc: DataGridIdentifiers.ReceiptFromProductionDoc,
        docLine: DataGridIdentifiers.ReceiptFromProductionDocLine,
      };
    case DocumentType.IssueForProduction:
      return {
        doc: DataGridIdentifiers.IssueForProductionDoc,
        docLine: DataGridIdentifiers.IssueForProductionDocLine,
      };
    case DocumentType.ProductionOrder:
      return {
        doc: DataGridIdentifiers.ProductionOrderDoc,
        docLine: DataGridIdentifiers.ProductionOrderDocLine,
      };
    case DocumentType.IssueForService:
      return {
        doc: DataGridIdentifiers.IssueForServiceDoc,
        docLine: DataGridIdentifiers.IssueForServiceDocLine,
      };
    case DocumentType.ReceiptFromService:
      return {
        doc: DataGridIdentifiers.ReceiptFromServiceDoc,
        docLine: DataGridIdentifiers.ReceiptFromServiceDocLine,
      };
    default:
      return DataGridIdentifiers.documentReports;
  }
};

export const getSourceDocDataGridIdentifiers = (docTypeId) => {
  switch (parseInt(docTypeId)) {
    case DocumentType.SalesQuotation:
      return {
        sourceDoc: DataGridIdentifiers.SourceSalesQuotationDoc,
        sourceDocLine: DataGridIdentifiers.SourceSalesQuotationDocLine,
      };
    case DocumentType.CustomerOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourceCustomerOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourceCustomerOrderDocLine,
      };
    case DocumentType.Delivery:
      return {
        sourceDoc: DataGridIdentifiers.SourceDeliveryNoteDoc,
        sourceDocLine: DataGridIdentifiers.SourceDeliveryNoteDocLine,
      };
    case DocumentType.Return:
      return {
        sourceDoc: DataGridIdentifiers.SourceReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceReturnDocLine,
      };
    case DocumentType.DownPaymentRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourceDownPaymentRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourceDownPaymentRequestDocLine,
      };
    case DocumentType.DownPayment:
      return {
        sourceDoc: DataGridIdentifiers.SourceDownPaymentDoc,
        sourceDocLine: DataGridIdentifiers.SourceDownPaymentDocLine,
      };
    case DocumentType.ARInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourceARInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceARInvoiceDocLine,
      };
    case DocumentType.PurchaseRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseRequestDocLine,
      };
    case DocumentType.PurchaseQuotation:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseQuotationDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseQuotationDocLine,
      };
    case DocumentType.PurchaseOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseOrderDocLine,
      };
    case DocumentType.PurchaseDelivery:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseDeliveryNoteDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseDeliveryNoteDocLine,
      };
    case DocumentType.GoodsReturn:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsReturnDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsReturnDocLine,
      };
    case DocumentType.APDownPaymentRequest:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPDownPaymentRequestDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPDownPaymentRequestDocLine,
      };
    case DocumentType.PurchaseAdvanceInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourcePurchaseAdvanceInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourcePurchaseAdvanceInvoiceDocLine,
      };
    case DocumentType.APInvoice:
      return {
        sourceDoc: DataGridIdentifiers.SourceAPInvoiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceAPInvoiceDocLine,
      };
    case DocumentType.InventoryTransfer:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryTransferDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryTransferDocLine,
      };
    case DocumentType.GoodsReceipt:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsReceiptDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsReceiptDocLine,
      };
    case DocumentType.GoodsIssue:
      return {
        sourceDoc: DataGridIdentifiers.SourceGoodsIssueDoc,
        sourceDocLine: DataGridIdentifiers.SourceGoodsIssueDocLine,
      };
    case DocumentType.InventoryCounting:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryCountingDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryCountingDocLine,
      };
    case DocumentType.InventoryCountingDif:
      return {
        sourceDoc: DataGridIdentifiers.SourceInventoryCountingDifDoc,
        sourceDocLine: DataGridIdentifiers.SourceInventoryCountingDifDocLine,
      };
    case DocumentType.ReceiptFromProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceReceiptFromProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceReceiptFromProductionDocLine,
      };
    case DocumentType.IssueForProduction:
      return {
        sourceDoc: DataGridIdentifiers.SourceIssueForProductionDoc,
        sourceDocLine: DataGridIdentifiers.SourceIssueForProductionDocLine,
      };
    case DocumentType.ProductionOrder:
      return {
        sourceDoc: DataGridIdentifiers.SourceProductionOrderDoc,
        sourceDocLine: DataGridIdentifiers.SourceProductionOrderDocLine,
      };
    case DocumentType.IssueForService:
      return {
        sourceDoc: DataGridIdentifiers.SourceIssueForServiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceIssueForServiceDocLine,
      };
    case DocumentType.ReceiptFromService:
      return {
        sourceDoc: DataGridIdentifiers.SourceReceiptFromServiceDoc,
        sourceDocLine: DataGridIdentifiers.SourceReceiptFromServiceDocLine,
      };
    default:
      return DataGridIdentifiers.documentReports;
  }
};

export const getDocumentTypeKeyUpperCase = (value) => {
  return Object.entries(DocumentType)
    .find(([_, v]) => v === parseInt(value))?.[0]
    ?.toUpperCase();
};

export const extractCopyPayload = (selectedValues, newDocType = null, defVals = {}, docName = '') => {
  const nowIso = dayjs().toISOString();

  const baseHeader = {
    ...selectedValues,
    docDate: nowIso,
    issueDate: nowIso,
    dueDate: nowIso,
    docStatus: newDocType ? DocStatus.OPENED : DocStatus.CANCELLATION,
    docTypeId: newDocType ?? selectedValues.docTypeId,
    mode: 'copy',
    note: `Forrása: ${docName} ${selectedValues.docNum}`,
  };

  if (parseInt(newDocType) === DocumentType.DownPaymentRequest) {
    if (!defVals.itemCode) {
      addNotification({
        content: 'Hiányzik az alapértelmezett cikk kódja!',
        type: NotificationType.ERROR,
      });
      return;
    }

    const unitPrice = selectedValues?.netInDocCur ?? 0;
    const vatCode = selectedValues?.docLine?.[0]?.vatCode ?? defVals?.vatCode;
    const vatPercent = selectedValues?.docLine?.[0]?.vatPercent ?? defVals?.vatPercent;

    const oneLine = {
      ...defVals,
      id: uuidv4(),
      qty: 1,
      unitPrice,
      vatPercent,
      vatCode,
      baseId: selectedValues.docId,
      baseDocnum: selectedValues.docNum,
      baseDocType: selectedValues.docTypeId,
      baseLine: null,
      dueDate: nowIso,
    };

    return {
      ...baseHeader,
      docLine: [oneLine],
    };
  }

  const docLine = (selectedValues?.docLine || [])
    .filter((line) => line?.lineStatus === DocStatus.OPENED && line?.opnQty > 0)
    .map((line) => ({
      ...line,
      id: uuidv4(),
      baseId: line.baseId ?? selectedValues.docId,
      baseDocnum: line.baseDocnum ?? selectedValues.docNum,
      baseDocType: line.baseDocType ?? selectedValues.docTypeId,
      baseLine: newDocType ? line.lineNum : line.baseLine,
      qty: line.opnQty,
      opnQty: 0,
      cplQty: 0,
      dueDate: nowIso,
      lineStatus: newDocType ? line.lineStatus : DocStatus.CANCELLATION,
    }));

  return {
    ...baseHeader,
    docLine,
  };
};

export const isCellEditable = ({ currentDocType, selectedValues }) => {
  return ({ field, row }) => {
    if (selectedValues.docStatus === DocStatus.PLANNED) return true;
    if (field === 'itemName' && !currentDocType?.editableItemName) return false;
    if (field === 'whsCode' && currentDocType?.inventoryAccounting && !row?.isNew) return false;
    if (field === 'qty' && currentDocType.inventoryAccounting && !row?.isNew && selectedValues.mode !== 'copy')
      return false;
    if (field === 'itemCode' && !row?.isNew) return false;
    return true;
  };
};

export const getLineEditableFields = (apiRef, rowId, { currentDocType, selectedValues }) => {
  const allCols = apiRef.current.getVisibleColumns?.() ?? [];
  const row = apiRef.current.getRow?.(rowId);
  const canEdit = isCellEditable({ currentDocType, selectedValues });

  const editableFields = allCols
    .filter((c) => c.type !== 'actions' && c.editable)
    .filter((c) => {
      return canEdit({ field: c.field, row });
    })
    .map((c) => c.field);

  return editableFields;
};
